import {
  Mail, Code2, Plug, Building2, Sparkles, TrendingUp, ScanLine, Camera, Eye,
  Zap, Star, Heart, Shield, Cloud, Image, Wand2, Palette, Crop, Layers,
  Award, Gem, Users, BarChart3, Settings, Globe, Lock, Rocket, Check, Download, Brush,
  Send, Bell, Package, CalendarClock, Clock, Phone,
} from "lucide-react";

export const ICON_MAP = {
  Mail, Code2, Plug, Building2, Sparkles, TrendingUp, ScanLine, Camera, Eye,
  Zap, Star, Heart, Shield, Cloud, Image, Wand2, Palette, Crop, Layers,
  Award, Gem, Users, BarChart3, Settings, Globe, Lock, Rocket, Check, Download, Brush,
  Send, Bell, Package, CalendarClock, Clock, Phone,
};

export const ICON_NAMES = Object.keys(ICON_MAP);

export const getIcon = (name) => ICON_MAP[name] || Sparkles;
